import { IAppState } from '../../../AppModulesWrapper';

export const selectIsPromotionToggleVisible = (state: IAppState): boolean => {
  return !state.servicePickerWidget.elementsVisibility.experiments?.hidePromotionToggle;
};
